import { isArray } from 'angular';

import { randomUUID } from '@contact/upgrade';

export let ImageReaderDirective = [
  '$q',
  'toastDeprecatedService',
  ($q, toast) => ({
    restrict: 'A',
    require: 'ngModel',
    scope: {
      ngModel: '=',
      addList: '=?',
    },
    link: (scope, element) => {
      element.bind('change', e => {
        let elem = e.target;
        // 2 MO
        let MAX_SIZE = 2 * 1024 * 1024;

        $q.all(Array.prototype.slice.call(elem.files, 0).map(readFile)).then(
          values => {
            if (elem.multiple) {
              values.forEach(value => {
                scope.ngModel.push(value);
              });
            } else {
              if (isArray(scope.ngModel)) {
                scope.ngModel.push(values[0]);
              } else if (scope.ngModel === '') {
                scope.ngModel = values[0];
              } else {
                scope.ngModel.name = values[0].name;
                scope.ngModel.image = values[0].image;
              }
              if (scope.addList != null) {
                scope.addList.push(values[0].name);
              }
            }
          },
          err => toast.alert(err)
        );

        function readFile(file) {
          let deferred = $q.defer();

          let reader = new FileReader();
          reader.onload = el => {
            let newName = randomUUID() + getFileExtension(file.name);
            deferred.resolve({
              name: newName,
              image: el.target && el.target['result'],
            });
          };
          reader.onerror = err => {
            deferred.reject(err);
          };
          if (file.size > MAX_SIZE) {
            deferred.reject('wallboard:toast.imageSizeError');
          } else {
            reader.readAsDataURL(file);
          }

          return deferred.promise;
        }

        function getFileExtension(fileName) {
          return fileName.substr(fileName.lastIndexOf('.'));
        }
      });
    },
  }),
];

export default 'cngImageReader';
